import {
	USER_CHECKING,
	USER_SUCCESS,
	USER_ERROR,
	USER_LOGOUT,
	TOKEN_CHECKING,
	TOKEN_SET_USER,
	TOKEN_VERIFIED,
	TOKEN_ERROR,
	TOKEN_EMPTY,
	USER_CLEAR_ERROR,
	SET_ROLE,
} from "../actions/actionTypes";

const initialState = {
	isLoading: false,
	validToken: false,
	id: "",
	username: "",
	email: "",
	err: "",
	role: "",
};

function userReducer(state = initialState, action) {
	switch (action.type) {
		case SET_ROLE:
			return { ...state, role: action.payload.role };

		case USER_CHECKING:
		case TOKEN_CHECKING:
			return { ...state, isLoading: true };
		case USER_SUCCESS:
		case TOKEN_SET_USER:
			return {
				...state,
				isLoading: false,
				validToken: true,
				id: action.payload.id,
				username: action.payload.username,
				email: action.payload.email,
				err: "",
			};
		case TOKEN_VERIFIED:
			return {
				...state,
				isLoading: false,
				validToken: true,
				err: "",
			};
		case USER_ERROR:
		case TOKEN_ERROR:
		case TOKEN_EMPTY:
			return {
				...state,
				isLoading: false,
				validToken: false,
				id: "",
				username: "",
				email: "",
				err: action.payload.err,
			};
		case USER_LOGOUT:
			return {
				...state,
				isLoading: false,
				validToken: false,
				id: "",
				username: "",
				email: "",
				err: "",
			};
		case USER_CLEAR_ERROR:
			return { ...state, err: "" };
		default:
			return state;
	}
}

export default userReducer;
